// extracted by mini-css-extract-plugin
module.exports = {"RecentSearch":"RecentSearch_RecentSearch__1Ryl6"};